'use strict';

export default {
  getEmailModel(state) {
    return state.emailModel;
  },
  getDefaultEmailModel(state) {
    return _.find(state.emailModel, function (o) {
      return o.isDefault === 1;
    });
  },
  getEmailSender(state) {
    return state.emailSender;
  },
  getEmailBalance(state) {
    return state.emailBalance;
  },
  getEmailReport(state) {
    return state.emailReport;
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/email/getters.js